import { AddOn } from './add-on';
import { Provider, AbstractType, Type } from '@angular/core';

export function registerAddOn<TAddOn extends AddOn<TParams>, TImpl extends TAddOn, TParams>(provide: AbstractType<TAddOn>, useClass: Type<TImpl>): Provider {
  return { provide, useClass, multi: true}
}
